import React from "react";
import Modal from "react-responsive-modal";
import success from "../../pics/paymentsuccessimg.png";

function PayPalPaymentSuccessfulModalGeneralTip({
  open,
  onClose,
  onModalClose,
}) {
  const handleClose = () => {
    onClose(); // This calls the provided onClose to close the modal
    onModalClose(); // Additional logic to be executed after the modal closes
  };
  return (
    <div>
      <Modal
        classNames={{
          modal:
            "!sm:px-10 !px-5 !py-12 !mx-0 rounded-[20px] !bg-[#030021] !max-w-[400px] !w-full  ",
          closeButton:
            "fill-white !bg-[#FFFFFF21] !p-1 w-[25px] h-[25px] flex items-center justify-center rounded-full [&>svg]:w-[15px] [&>svg]:h-[15px] ",
        }}
        open={open}
        onClose={handleClose}
        center
        closeOnOverlayClick={false}
      >
        <div className=" flex flex-col items-center  gap-4 w-full">
          <div>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginBottom: "5%",
              }}
            >
              <img src={success} alt="" />
            </div>
            <p className="text-[32px] font-bold leading-[32px] tracking-normal  text-center text-white">
              Payment Successful!
            </p>
            <p className="text-[20px] font-[500] leading-[25px] tracking-normal  text-center text-[#BDBDBD] mt-5 ">
              Thank you for your payment. Your transaction is complete.
            </p>
          </div>
        </div>
      </Modal>
    </div>
  );
}

export default PayPalPaymentSuccessfulModalGeneralTip;
